// extracted by mini-css-extract-plugin
export default {"a":"RequestVmButton_a__xxUm4","requestVmButton":"RequestVmButton_requestVmButton__EbrOI"};